import { Box } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import fuelCardBannerImage from "@/../public/img/petcover/fuel-card-banner-100-2.png";
import { InsuranceGiftVoucherPromotionActive } from "@/models/AdInsuranceModel";

export function InsuranceFuelCardBanner() {
  if (!InsuranceGiftVoucherPromotionActive()) {
    return null;
  }

  return (
    <Box
      component={Link}
      href="https://quotep-horse.au.petcovergroup.com/index?SubAgentCode=026286"
      target="_blank"
      sx={{
        display: "block",
        width: "100%",
        position: "relative",
        height: "240px",
        img: {
          objectFit: "contain",
        },
      }}
    >
      <Image src={fuelCardBannerImage} alt="Fuel Card Promotion" fill />
    </Box>
  );
}
